// extracted by mini-css-extract-plugin
export default {"pageTitleRow":"ReceptionistCommon_pageTitleRow__gmz6Q","tabLabelWithBadge":"ReceptionistCommon_tabLabelWithBadge__-3qW8"};